import { CommonCenterResponse } from '@/api/services/common/center/common-center.dto'
import axios from 'axios'
import { orderBy } from 'lodash'
import { TextNormalization } from '@/shared/util/text-normalization'

class CommonCenterService {
    async getActiveCenters(): Promise<CommonCenterResponse[]> {
        const response = await axios.get<CommonCenterResponse[]>('/centers/active')
        return orderBy(response.data, element => TextNormalization.removeDiacritics(element.name), ['asc'])
    }
}
export const commonCenterService = new CommonCenterService()
